const chartSize = {
  EXTRA_LARGE: 'EXTRA_LARGE',
  LARGE: 'LARGE',
  NORMAL: 'NORMAL',
  SMALL: 'SMALL',
  EXTRA_SMALL: 'EXTRA_SMALL',
};
export default chartSize;
